import { render } from "./BrandsSection.vue?vue&type=template&id=2f2ba997"
import script from "./BrandsSection.vue?vue&type=script&lang=js"
export * from "./BrandsSection.vue?vue&type=script&lang=js"

import "./BrandsSection.vue?vue&type=style&index=0&id=2f2ba997&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__